module.exports = __webpack_public_path__ + "static/media/showcase-img9.b7d8ef71.jpg";